<script lang="ts">
	import { Button, Text, Textarea, toast } from '@Shelly/shelly-design-system/index';
	import { postReq } from 'src/services/http';
	import { devices } from 'src/stores/lists/devices';
	import { format } from 'svelte-i18n';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	export let device;
	let value = device?.note || '';

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: saveDeviceNote,
				loading: false,
				disabled: (!device?.note && !value.trim()) || value.trim() === device?.note,
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});

	const saveDeviceNote = async () => {
		const editedDevice = { ...device, note: value.trim() };
		const res = await postReq('interface/device/save', {
			id: editedDevice.id,
			data: JSON.stringify(editedDevice),
		});

		if (res.isok) {
			devices.update(editedDevice);
			toast.open({
				type: 'success',
				title: $format('toast_success_device_note', {
					default: 'Successfully saved device note.',
				}),
			});
		} else {
			toast.open({
				type: 'danger',
				title: $format('toast_error_device_note', {
					default: 'Failed to save device note.',
				}),
			});
		}
	};
</script>

<Text styleType="body-small" class="mb-s">
	{$format('text_description_device_note', {
		default:
			'Add a short note to help identify or describe this device, or keep track of any key details.',
	})}
</Text>
<Textarea
	size="m"
	resize="auto"
	class="width-full mb-s"
	label={$format('label_textarea_device_note', {
		default: 'Add the device note here...',
	})}
	maxChar={100}
	bind:value
	id="textarea-5cgafix"
	aria-labelledby="textarea-5cgafix"
/>
{#if !$showNewLayout}
	<Button
		disabled={(!device?.note && !value.trim()) || value.trim() === device?.note}
		size="m"
		width="full"
		on:click={saveDeviceNote}
	>
		{$format('button_save')}
	</Button>
{/if}
